import { create } from "zustand";

interface SettingsState {
  showSettingsModal: boolean;
  showShareModal: boolean;
  showGroupChat: boolean;
  showSidebar: boolean;
  showMap: boolean;
  settings: {
    visibility: "private" | "public";
    title: string;
  };
  setShowSettingsModal: (show: boolean) => void;
  setShowMap: (show: boolean) => void;
  setShowSidebar: (show: boolean) => void;
  setShowShareModal: (show: boolean) => void;
  setShowGroupChat: (show: boolean) => void;
  setSettings: (settings: Partial<SettingsState["settings"]>) => void;
}

export const useItinerarySettingsStore = create<SettingsState>((set) => ({
  showSettingsModal: false,
  showShareModal: false,
  showMap: false,
  showGroupChat: false,
  showSidebar: false,
  settings: {
    visibility: "private",
    title: "",
  },
  setShowMap: (show) => set({ showMap: show }),
  setShowSidebar: (show) => set({ showSettingsModal: show }),
  setShowSettingsModal: (show) => set({ showSettingsModal: show }),
  setShowShareModal: (show) => set({ showShareModal: show }),
  setShowGroupChat: (show) => set({ showGroupChat: show }),
  setSettings: (updatedSettings) =>
    set((state) => ({
      settings: { ...state.settings, ...updatedSettings },
    })),
}));
